import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TrackInvertedSlider from './TrackInvertedSlider';
import ClientProvider from './client';
export default createDemo(import.meta.url, TrackInvertedSlider, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/slider/demos/track-inverted/TrackInvertedSlider.tsx",
    "fileName": "TrackInvertedSlider.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\nimport Slider from '@mui/material/Slider';\n\nconst Separator = styled('div')(\n  ({ theme }) => `\n  height: ${theme.spacing(3)};\n`,\n);\n\nconst marks = [\n  {\n    value: 0,\n    label: '0°C',\n  },\n  {\n    value: 20,\n    label: '20°C',\n  },\n  {\n    value: 37,\n    label: '37°C',\n  },\n  {\n    value: 100,\n    label: '100°C',\n  },\n];\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nexport default function TrackInvertedSlider() {\n  return (\n    <Box sx={{ width: 250 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Typography id=\"track-inverted-slider\" gutterBottom>\n        Inverted track\n      </Typography>\n      <Slider\n        track=\"inverted\"\n        aria-labelledby=\"track-inverted-slider\"\n        getAriaValueText={valuetext}\n        defaultValue={30}\n        marks={marks}\n      />\n      <Separator />\n      <Typography id=\"track-inverted-range-slider\" gutterBottom>\n        Inverted track range\n      </Typography>\n      <Slider\n        track=\"inverted\"\n        aria-labelledby=\"track-inverted-range-slider\"\n        getAriaValueText={valuetext}\n        defaultValue={[20, 37]}\n        marks={marks}\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 61,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\nimport Slider from '@mui/material/Slider';\n\nconst Separator = styled('div')(\n  ({ theme }) => `\n  height: ${theme.spacing(3)};\n`,\n);\n\nconst marks = [\n  {\n    value: 0,\n    label: '0°C',\n  },\n  {\n    value: 20,\n    label: '20°C',\n  },\n  {\n    value: 37,\n    label: '37°C',\n  },\n  {\n    value: 100,\n    label: '100°C',\n  },\n];\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nexport default function TrackInvertedSlider() {\n  return (\n    <Box sx={{ width: 250 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Typography id=\"track-inverted-slider\" gutterBottom>\n        Inverted track\n      </Typography>\n      <Slider\n        track=\"inverted\"\n        aria-labelledby=\"track-inverted-slider\"\n        getAriaValueText={valuetext}\n        defaultValue={30}\n        marks={marks}\n      />\n      <Separator />\n      <Typography id=\"track-inverted-range-slider\" gutterBottom>\n        Inverted track range\n      </Typography>\n      <Slider\n        track=\"inverted\"\n        aria-labelledby=\"track-inverted-range-slider\"\n        getAriaValueText={valuetext}\n        defaultValue={[20, 37]}\n        marks={marks}\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 61,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/Typography",
      "@mui/material/Slider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
